module.exports = global["surveylab_survey_itemEventLogging"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./item-event-logging.ts");